<template>
  <div class="container">
    <ModelConfig
      :secTitle="
        'Selecione o <b>Interior</b> do seu <b>' +
        this.resumeData.model +
        '</b>'
      "
      :showLeftCol="showCarLook"
      :showRigthCol="showCarOptions"
    >
      <template v-slot:carLook>
        <Model
          :isMobile="isMobile"
          :isExterior="false"
          :panoramImg="pannellumImg"
        />
      </template>
      <template v-slot:carOptions>
        <p class="sidebarTitle">
          <b>Selecionar o {{ staticText.dsgIntLabels[0] }}</b>
        </p>
        <DetailsViewNav
          :isMobile="isMobile"
          :showContent="showCarOptions"
          @change-view="displayCarOptions"
        >
          <span
            ><b>Selecionar {{ staticText.dsgIntLabels[0] }}</b> (
            {{ intColorsArr.length }} {{ staticText.dsgIntLabels[1] }} )</span
          >
        </DetailsViewNav>
        <div v-if="intColorsArr.length == 0">
          <p>
            Lamentamos, no momento não há cores disponiveis para a respetiva
            versão
          </p>
          <p>Por favor, tente mais tarde.</p>
        </div>
        <div v-else class="container-wrap">
          <Colors
            :colorType.sync="mainColID"
            :currColor="mainColID"
            :colors="intColorsArr"
            :contLabel="materialType"
          />
        </div>
      </template>
    </ModelConfig>
    <p
      v-show="showCarLook && isMobile"
      class="btn-secondary"
      @click="displayCarOptions"
    >
      <span
        ><b>Selecionar {{ staticText.dsgIntLabels[0] }}</b> ({{
          intColorsArr.length
        }}
        {{ staticText.dsgIntLabels[1] }})</span
      >
    </p>
    <div class="container-wrapContent">
      <FeaturedBlock
        :secTitle="dataBO.destaqueSect.destaqueTitle"
        :content="dataBO.destaqueSect.destaqueContent"
      />
      <Accordion :accordionObj="dataBO.faqs.faqsInt" />
      <LegalMentions />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import ModelConfig from "../components/TemplateParts/ModelConfig/ModelConfig.vue";
import Model from "../components/TemplateParts/Model/Model.vue";
import DetailsViewNav from "../components/TemplateParts/SimpleContent/DetailsViewNav.vue";
import Colors from "../components/TemplateParts/SimpleContent/Colors.vue";
import Accordion from "../components/TemplateParts/SimpleContent/Accordion.vue";
import FeaturedBlock from "../components/TemplateParts/SimpleContent/FeaturedBlock.vue";
import LegalMentions from "../components/TemplateParts/SimpleContent/LegalMentions.vue";
import { comonFunctions } from "../mixins/comonFunctions";
import { metatags } from "../mixins/comonMetaTags";
import { handleDataLayer } from "../mixins/handleDataLayer";

export default {
  name: "DesignInterior",
  components: {
    ModelConfig,
    Model,
    DetailsViewNav,
    Colors,
    Accordion,
    FeaturedBlock,
    LegalMentions,
  },
  mixins: [metatags, comonFunctions, handleDataLayer],
  data() {
    return {
      seoData: {
        title: "Configurador",
        titleTemplate: "Interior",
        author: "Hyundai Portugal",
        og_description:
          "Com o Configurador Hyundai, pode escolher e personalizar o seu Hyundai de sonho. Selecione o seu modelo favorito e escolha todas as características de acordo com as suas preferências.",
        og_title: "Configurador Hyundai - Hyundai Portugal",
        og_locale: "pt_PT",
        og_type: "article",
        og_site_name: "Hyundai Portugal",
      },
      mainColID: 0,
      intColorsArr: [],
      pannellumImg: "",
      materialType: ""
    };
  },
  provide: {
    page: "Interior",
    isExtColor: false,
  },
  beforeMount() {
    let id = this.resumeData.configSelected.dsgExt?.colorid;
    this.mainColID = id ? id : 0;
  },
  mounted() {
    let intArr = this.getPanoramData(
      this.resumeData.modelid,
      this.resumeData.versionID
    );
    if (intArr) {
      Object.entries(intArr).forEach((el) =>
        this.intColorsArr.push({
          id: el[1].idColor,
          designation: el[1].designation,
          img360: el[1].panoramImg,
          factoryCode: el[1].factoryCode,
          materialType: el[1].materialType,
        })
      );
      this.mainColID = this.intColorsArr[0]?.id;
    }
  },
  beforeRouteLeave(to, prev, next) {
    if (to.name == "Resume") {
      this.setDataLayerStepSelection(4);
    }
    next();
  },
  watch: {
    mainColID: function (val, prev) {
      if (val) {
        const selectdColor = this.intColorsArr.find((el) => el.id == val);
        this.pannellumImg = selectdColor?.img360;
        this.materialType = selectdColor?.materialType || "Tecido";
      }
      if (prev != 0 && this.isMobile) this.displayCarOptions();
    },
  },
  computed: {
    ...mapState(["resumeData"]),
    ...mapGetters({
      getPanoramData: "panoram360/getPanoramaicImgByVersion",
    }),
  },
  methods: {
    getPageTitle() {
      return `Selecione o <b>Interior</b> do seu ${this.resumeData.model}`;
    },
  },
};
</script>
